import { atom } from "recoil";

export const partnerSettingsStore = atom({
	key: "partnerSettingsStore",
	default: {
		loaded: false,
		data: false,
		error: {
			text: "",
			code: 0,
			timestamp: 0,
		},
	},
});
